import { toast } from 'sonner';

// Define a reusable options type for all notification channels
interface NotifyOptions {
    description?: string;
    duration?: number;
    id?: string | number; // Pass a static string/number here to prevent duplicates
}

export const notify = {
    // Clear out any active notifications instantly
    dismissAll: () => {
        toast.dismiss();
    },

    success: (message: string, options?: NotifyOptions) => {
        const customId = options?.id;
        const generatedId = toast.success(message, {
            id: customId,
            description: options?.description,
            duration: options?.duration ?? 4000,
            action: {
                label: '✕',
                onClick: () => toast.dismiss(customId || generatedId),
            },
        });
        return generatedId;
    },

    error: (message: string, options?: NotifyOptions) => {
        const customId = options?.id;
        const generatedId = toast.error(message, {
            id: customId,
            description: options?.description,
            duration: options?.duration ?? Infinity, // Errors stay open by default
            action: {
                label: '✕',
                onClick: () => toast.dismiss(customId || generatedId),
            },
        });
        return generatedId;
    },

    warning: (message: string, options?: NotifyOptions) => {
        const customId = options?.id;
        const generatedId = toast.warning(message, {
            id: customId,
            description: options?.description,
            duration: options?.duration ?? 4000,
            action: {
                label: '✕',
                onClick: () => toast.dismiss(customId || generatedId),
            },
        });
        return generatedId;
    },

    info: (message: string, options?: NotifyOptions) => {
        const customId = options?.id;
        const generatedId = toast.info(message, {
            id: customId,
            description: options?.description,
            duration: options?.duration ?? 4000,
            action: {
                label: '✕',
                onClick: () => toast.dismiss(customId || generatedId),
            },
        });
        return generatedId;
    },
};
